module.exports = __webpack_public_path__ + "static/media/icon_home.a7c37a2e.svg";